export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const faqItems: FaqItem[] = [
  {
    id: 'f1',
    question: '海角吃瓜是什么？',
    answer: '海角吃瓜是一个专注于事件始末、真相时间线与后续进展整理的中文资讯平台。我们以清晰的时间线、客观的信息分级和持续的后续更新，帮助用户在信息碎片中快速理清事件的来龙去脉。',
  },
  {
    id: 'f2',
    question: '这里的信息从哪来、是否可信？',
    answer: '我们只整理已在公开渠道发布的信息，并对每条内容标注核实状态，包括"官方发布""多方佐证""存有分歧""待核实"等。对于仍存争议的内容，我们会明确说明，而不是武断下结论。',
  },
  {
    id: 'f3',
    question: '时间线会一直更新吗？',
    answer: '会的。只要事件有新的公开进展，我们就会在对应节点追加更新，并对早期内容进行复核与修正，确保时间线尽量贴近真实走向。你可以在页面下方留下反馈提醒我们关注新动态。',
  },
  {
    id: 'f4',
    question: '你们和事件当事方有关系吗？',
    answer: '没有。我们保持独立第三方立场，不接受任何当事方付费改写内容，也不为任何单方说法背书。我们只负责客观呈现各方说法，并把核实情况清楚标出，由读者自行判断。',
  },
  {
    id: 'f5',
    question: '如何判断一条"瓜"是否可信？',
    answer: '建议从三个维度判断：信息是否来自权威或一手渠道、是否有多条独立来源交叉印证、发布语境是否完整。你在我们这里看到的所有内容，也会被标注上述核实状态，便于你快速判断可信度。',
  },
  {
    id: 'f6',
    question: '内容有误时如何更正？',
    answer: '如果发现我们的梳理存在事实性错误或遗漏，欢迎通过页面底部的联系方式提交更正信息。我们核实后会第一时间在对应节点标注勘误并修正正文。',
  },
];